import fetch from 'cross-fetch';

export default async (
  url: RequestInfo,
  options: RequestInit | undefined,
): Promise<Response> => fetch(url, options);
